export default __webpack_public_path__ + "static/media/add.ab3854ce.svg";